var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"component",staticClass:"svg-icon",class:[
        _vm.size && 'svg-icon--width-' + _vm.size,
        (_vm.height && !_vm.width) ? 'svg-icon--height-' + _vm.height : (_vm.size && 'svg-icon--height-' + _vm.size),
        _vm.middle && 'svg-icon--middle'
    ]},[_c(_vm.svgComponent,{tag:"div",staticClass:"svg-icon__svg",style:(_vm.svgStyle)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }